import SectionHeader from "@/components/SectionHeader";
import Button from "@/components/Button";
import {
  AdjustmentsHorizontalIcon,
  ArrowsRightLeftIcon,
  BeakerIcon,
  CameraIcon,
  CheckBadgeIcon,
  CursorArrowRaysIcon,
  ScaleIcon,
  ShieldCheckIcon,
  SparklesIcon,
  StarIcon,
} from "@heroicons/react/24/outline";

const cardStyles =
  "rounded-3xl bg-slate-50/60 p-6 shadow-[0_12px_40px_-28px_rgba(15,23,42,0.45)] ring-1 ring-black/5";

const defaultPresets = {
  howItWorks: [
    {
      title: "1. Ausstattung prüfen",
      text: "Wir bewerten Kamera, Licht, Druckoptionen, Software, Versand und Support anhand klarer Kriterien.",
      icon: "camera",
    },
    {
      title: "2. Preise vergleichen",
      text: "Alles auf einen Blick: Ausstattung, Features & Preise.",
      icon: "compare",
    },
    {
      title: "3. Anbieter auswählen",
      text: "Wähle die Fotobox, die zu deinem Budget und deinen Anforderungen passt – direkt beim Anbieter buchbar.",
      icon: "checkbadge",
    },
  ],
  trust: [
    {
      title: "Unabhängiger Vergleich",
      text: "Wir stellen Anbieter strukturiert gegenüber und bewerten Ausstattung, Funktionen, Preis-Leistung und Service nach festen Kriterien.",
      icon: "adjustments",
    },
    {
      title: "Transparente Bewertung",
      text: "Alle Unterschiede auf einen Blick – verständlich aufbereitet und nachvollziehbar erklärt.",
      icon: "star",
    },
    {
      title: "Klare Orientierung",
      text: "Klare Einordnung der Optionen, damit du schnell die passende Fotobox für dein Event findest.",
      icon: "cursorarrowrays",
    },
  ],
};

function Icon({ name }) {
  if (name === "camera")
    return <CameraIcon className="h-5 w-5 text-[#FF5744]" aria-hidden />;
  if (name === "star")
    return <StarIcon className="h-5 w-5 text-[#FF5744]" aria-hidden />;
  if (name === "adjustments")
    return (
      <AdjustmentsHorizontalIcon
        className="h-5 w-5 text-[#FF5744]"
        aria-hidden
      />
    );
  if (name === "compare")
    return (
      <ArrowsRightLeftIcon className="h-5 w-5 text-[#FF5744]" aria-hidden />
    );
  if (name === "cursorarrowrays")
    return (
      <CursorArrowRaysIcon className="h-5 w-5 text-[#FF5744]" aria-hidden />
    );
  if (name === "checkbadge")
    return <CheckBadgeIcon className="h-5 w-5 text-[#FF5744]" aria-hidden />;
  return null;
}

export default function FeatureGridSection({ title, subtitle, items, preset }) {
  const resolvedItems = items || defaultPresets[preset];

  return (
    <SectionHeader title={title} subtitle={subtitle}>
      <div className="mt-10 grid gap-6 md:grid-cols-3">
        {resolvedItems?.map((item) => (
          <div key={item.title} className={cardStyles}>
            <div className="flex items-start gap-3">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-white ring-1 ring-slate-200/70">
                <Icon name={item.icon} />
              </span>
              <div>
                <h3 className="text-lg font-semibold tracking-tight">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm leading-6 text-slate-600">
                  {item.text}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-10 flex justify-center">
        <Button
          href="/fotobox-vergleich"
          variant="primary"
          className="px-8 py-3"
        >
          Zum Fotobox-Vergleich
        </Button>
      </div>
    </SectionHeader>
  );
}
